import { useState } from "react";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { isFilledArray } from "../../../../../utils";
import { Button } from "../../../../Helper/Button";
import { useQcEntities } from "../../QcEntityContext";
import usePatchAvocado from "../../usePatchAvocado";

const convertToFloat = (value: string) => {
    // Replace any non-numeric characters (including letters)
    let cleanedCell = value.replace(/[^\d,.-]/g, "");
    // Replace commas with periods
    cleanedCell = value.replace(",", ".");
    // Convert to float, if not empty
    return cleanedCell ? parseFloat(cleanedCell) : cleanedCell;
};

type BulkCopyPasteFormModalProps = {
    isOpen: boolean;
    toggleModal(isOpen: boolean): void;
    field: string;
}

export const BulkCopyPasteFormModal = ({ isOpen, toggleModal, field }: BulkCopyPasteFormModalProps) => {
    const { check } = useQcEntities();
    const [value, setValue] = useState("");

    const patchAvocado = usePatchAvocado();

    const closeModal = () => toggleModal(false);

    const onPaste = async () => {
        const data = value.split("\n").map((i) => i.split("\t"));
        await Promise.all(
            // * loop over all the known fruit, check if there is corresponding data in the pasted excel data
            check.avocados.flatMap((i, index) => {
                const columns = data[index];

                if (!isFilledArray(columns)) {
                    return [];
                }

                // * when there are more than 1 column and field = pressure then copy 2 fta
                if (columns.length >= 2 && field === "2_pressures") {
                    return [
                        patchAvocado(i, "pressure_1", convertToFloat(columns[0])),
                        patchAvocado(i, "pressure_2", convertToFloat(columns[1])),
                    ];
                }

                return [patchAvocado(i, field, convertToFloat(columns[0]))];
            })
        );

        closeModal();
    };

    return (
        <Modal isOpen={isOpen} toggle={closeModal}>
            <ModalHeader toggle={closeModal}>Paste Bulk Data</ModalHeader>

            <ModalBody>
                <FormGroup>
                    <Label for="copyFromExcel">Paste data here</Label>

                    <Input type="textarea" value={value} onChange={(e) => setValue(e.target.value)} name="text" id="copyFromExcel" />
                </FormGroup>
            </ModalBody>

            <ModalFooter>
                <Button color="primary" onClick={onPaste}>Paste</Button>
                <Button color="secondary" onClick={closeModal}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};
